import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useDetectTrafficSource } from '../tag-manager/detectTrafficSource';

export const useTrafficSource = () => {
  const location = useLocation();
  // const {} = useParams();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('gclid') || params.has('fbclid') || params.has('ttclid') || params.has('utm_campaign')) {
      let source = '';

      if (params.get('gclid')) {
        source = 'google';
      } else if (params.get('fbclid')) {
        source = 'facebook';
      } else if (params.get('ttclid')) {
        source = 'tiktok';
      }

      const campaign = params.get('utm_campaign') || '';

      useDetectTrafficSource({
        source,
        campaign
      });

      const cleanUrl = location.pathname + location.hash;
      window.history.replaceState({}, '', cleanUrl);
      // navigate(cleanUrl, { replace: true });
      console.log('🔄 Parámetros de URL limpiados');
    }
  }, [location]);
};
